module.exports = __webpack_public_path__ + "static/media/BoxPlotQ8_5.03762597.svg";